import Vue from "vue";
import VueI18n from "vue-i18n";

//element �h�y�B�z
import locale from "element-ui/lib/locale";
import elEn from "element-ui/lib/locale/lang/en";
import elTw from "element-ui/lib/locale/lang/zh-TW";

Vue.use(VueI18n);

//�N���locales�ت������O�ޤJ�åB��X��i18n�ݭn���榡
function loadLocaleMessages() {
    //�d��locales��󤤦��h�ֻy�t
    const locales = require.context(
        "./locales",
        true,
        /.json$/
    );
    const messages = {};
    locales.keys().forEach(file => {
        const keyArr = file.split('/');
        keyArr.shift();
        messages[keyArr.join('.').replace(/\.json$/g, '')] = locales(file);
    });
    return {
        tw: { ...messages.tw, ...elTw },
        en: { ...messages.en, ...elEn },
    };
}
const i18n = new VueI18n({
    locale: "tw",
    messages: loadLocaleMessages()
});
locale.i18n((key, value) => i18n.t(key, value));

export default i18n;